import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../constants';

export const formatPrice = (price: number, fractionDigits = 0) => {
  /**
   * Formats a price number into a currency string
   * @param price - The price number to format
   * @returns The formatted price string
   */
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'currency',
    currency: DEFAULT_CURRENCY,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(price);
};
